module.exports = __webpack_public_path__ + "img/upload_excel.ae5ae041.svg";